import sendToServer from "./send-to-server";

const Nz = {
  init() {
    if ($(".video-thumbnail").length > 0) {
      $(".video-thumbnail").on("click", this.handleThumbnailClick.bind(this));
    }
    if ($(".video-thumbnail-closer").length > 0) {
      $(".video-thumbnail-closer").on(
        "click",
        this.handleCloserClick.bind(this)
      );
    }
    if ($(".video-ender").length > 0) {
      $(".video-ender").on("click", this.handleEndVideoClick.bind(this));
    }

    if ($(".nz-after-solve-some").length > 0) {
      $(".nz-after-solve-some").on(
        "click",
        this.handleAfterSolveSomeClick.bind(this)
      );
    }

    document.querySelectorAll(".nz-work-readiness-next").forEach((element) => {
      element.addEventListener("click", () => {
        if (element.dataset.saveHobbies) {
          this.saveHobbies();
        }
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        document.querySelectorAll(".nz-work-readiness").forEach((section) => {
          section.classList.remove("visible");
        });
        document
          .getElementById(element.dataset.target)
          .classList.add("visible");
      });
    });

    document.querySelectorAll(".mentor-email").forEach((element) => {
      element.addEventListener("click", (e) => {
        let ret = confirm(
          "Click 'OK' to email our team who help people into jobs (Project Nikau) to set up a chat (or say kōrero)."
        );

        if (!ret) {
          e.preventDefault();
        }

        return ret;
      });
    });
  },

  saveHobbies() {
    let hobbies = [document.querySelector(".hobby-form .other-hobby").value];
    document
      .querySelectorAll(".hobby-form input[type='checkbox']")
      .forEach((checkbox) => {
        if (checkbox.checked) {
          hobbies.push(checkbox.value);
        }
      });
    sendToServer("/api/v2/hobbies/", { hobbies: hobbies });
  },

  handleThumbnailClick(event) {
    let $link = $(event.target).closest(".video-thumbnail");
    document.getElementById($link.data("vid")).classList.add("visible");
  },

  handleCloserClick(event) {
    $(event.target).closest(".video-popup").removeClass("visible");
    $(".video-popup iframe").each(function () {
      this.contentWindow.postMessage(
        '{"event":"command","func":"stopVideo","args":""}',
        "*"
      );
    });
  },

  handleEndVideoClick(event) {
    sendToServer(
      "/api/v2/nz_statuses/",
      { status: "video_done" },
      this.handleSubmissionResponse.bind(this)
    );
  },

  handleSubmissionResponse() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    location.reload();
  },

  handleAfterSolveSomeClick(event) {
    let button = event.target.closest(".nz-after-solve-some");
    sendToServer("/api/v2/nz_statuses/", { status: "general_flow" }, () => {
      if (button.classList.contains("nz-not-ready-yet")) {
        location.reload();
      } else if (button.classList.contains("nz-ready-to-apply")) {
        location = "/app/opportunities/all";
      } else if (button.classList.contains("nz-speak-to-mentor")) {
        if (button.dataset.email.length > 0) {
          sendToServer("/api/v2/dashboard_share", {}, null, "PATCH");
          alert("Thanks! The mentor will be in touch to book a session.");
          location.reload();
        } else {
          $(".dashboard-share-form").show();
          $(button.closest(".onboarding-screen")).hide();
        }
      }
    });
  },
};

$(document).ready(() => {
  Nz.init();
});
